import { createStore } from 'zustand';
import { WalletAuthFormState, WalletAuthFormStateFunction, WalletAuthState } from '@v2/contexts/wallet/WalletContext';

export const CreateWalletStore = (predefinedData?: Partial<WalletAuthFormState>) => {
    return createStore<WalletAuthFormState & WalletAuthFormStateFunction>()(set => ({
        walletAuthState: 'dob',
        isBlocked: false,
        setWalletAuthState: (walletAuthState: WalletAuthState) => set({ walletAuthState }),
        setDob: dob => set({ dob }),
        setOtpVm: otpVm => set({ otpVm }),
        setPin: pin => set({ pin }),
        setWalletResultMessage: walletResultMessage => set({ walletResultMessage }),
        setWalletResultState: resultState => set({ resultState }),
        setTransactionData: transactionInfo => set({ transactionInfo }),
        setIsBlocked: isBlocked => set({ isBlocked }),
        ...predefinedData,
    }));
};
